import React from 'react';
import {
	AGENCY_PROJECT,
	PROJECT_CAR,
	PROJECT_CRI,
	PROJECT_CSV
} from './Constants';

const InputParamsContext = React.createContext();

export function InputParamsProvider({ children }) {
	let RANKING = null;
	let PRODUCT_NAME = null;
	let DATA = null;

	const urlParams = getUrlParams();
	const rankCookie = getCookie('axa-product');
	const productNameCookie = getCookie('page-product');

	if (urlParams['rank'] || window['rank'] || rankCookie) {
		RANKING = urlParams['rank'] || window['rank'] || rankCookie;
	}

	if (productNameCookie) {
		PRODUCT_NAME = productNameCookie;
	}

	if (urlParams['data'] && !RANKING) {
		if (urlParams['data'].toLowerCase() === 'cc') {
			DATA = PROJECT_CAR;
		} else if (urlParams['data'].toLowerCase() === 'cr') {
			DATA = PROJECT_CRI;
		} else if (urlParams['data'].toLowerCase() === 'cs') {
			DATA = PROJECT_CSV;
		} else if (urlParams['data'].toLowerCase() === 'ag') {
			DATA = AGENCY_PROJECT;
		}
	}

	return (
		<InputParamsContext.Provider
			children={children}
			value={[RANKING, PRODUCT_NAME, DATA]}
		/>
	);
}

export function useInputParams() {
	return React.useContext(InputParamsContext);
}

function getCookie(cname) {
	var name = cname + '=';
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return '';
}

function deleteCookie(cname) {
	document.cookie =
		cname + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
}

function getUrlParams() {
	const urlParams = [];

	let e,
		a = /\+/g, // Regex for replacing addition symbol with a space
		r = /([^&=]+)=?([^&]*)/g,
		d = function (s) {
			return decodeURIComponent(s.replace(a, ' '));
		},
		q = window.location.search.substring(1);

	while ((e = r.exec(q))) {
		urlParams[d(e[1])] = d(e[2]);
	}

	return urlParams;
}
